
import React from 'react';
import ServiceCard from './ServiceCard';
import { MessageSquare, Zap, BookOpen, Lightbulb } from 'lucide-react';

const ServicesSection = () => {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Wat doet Noord AI?</h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Elke organisatie is anders — en daarom kijken we samen naar wat AI voor jouw specifieke situatie kan betekenen.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <ServiceCard 
            title="AI Advies op maat" 
            description="We leggen je helder uit wat AI is, en hoe jij het praktisch kunt toepassen in jouw bedrijf."
            icon={MessageSquare}
          />
          <ServiceCard 
            title="Snelle implementaties" 
            description="Van chatbots tot automatisering — we helpen je om snel iets werkends te bouwen."
            icon={Zap}
          />
          <ServiceCard 
            title="Workshops & Trainingen" 
            description="Leer hoe AI werkt, en ontdek hoe jij of je team het zelf kunnen gebruiken."
            icon={BookOpen}
          />
          <ServiceCard 
            title="Probleemoplossing met AI" 
            description="Heb je een specifiek probleem? Wij zoeken de juiste AI-tool of bouwen er één."
            icon={Lightbulb}
          />
        </div>
        
        <div className="text-center mt-12">
          <p className="text-lg text-gray-700">
            Je hoeft geen tech-expert te zijn — wij zorgen voor duidelijke uitleg en praktische stappen.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
